export const USDC_PRECISION = 6
